<template>
    <v-dialog max-widht="80%" persistent style="border-radius: 10px;" v-model="show">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-on="on"
                v-bind="attrs"
                fab
                dark
                color="primary"
                :small="size === 's'"
                :large="size === 'l'"
                class="mb-2 mr-2"
            >
                <v-icon>mdi-help</v-icon>
            </v-btn>
        </template>
        <help-card :items="items" :title="title" :intro="intro" @close="show = false"/>
    </v-dialog>
</template>
<script>
import HelpCard from '../Cards/HelpCard.vue';

export default {
    name: "HelpDialog",
    components: {
        HelpCard,
    },
    props: {
        items: {
            type: Array, 
            required: true
        },
        intro: {
            type: String, 
            default() {
                return null;
            }
        },
        title: {
            type: String, 
            default() {
                return null;
            }
        },
        size: {
            type: String, 
            default() {
                return 'm';
            }
        }
    },
    data: () => ({
        show: false,
    })
}
</script>
<style>
    
</style>